import { ITransferItemSelectable } from "../../../../../pages/catalog/components/transferItemsForm/TransferItemsForm"
import { IDevice } from "../../../../device/interface/Device"
import { IOperator } from "../../../../operator/domains/models/Operator"
import { ITransferOrderItemsRequest } from "../../../domain/dtos/TransferAccountItemsRequest"
import { IConsumeService } from "../../../domain/interfaces/IConsumeService"

const TransferOrderItemsUseCase = async (service: IConsumeService, values: { items: ITransferItemSelectable[], fromTag: string, toTag: string, operator: IOperator, device: IDevice, annotation?: string }) => {
    const request: ITransferOrderItemsRequest = {
        localId: values.device.localId,
        fromTag: values.fromTag,
        toTag: values.toTag,
        items: values.items.map(item => ({
            accountHistoryItemId: item.id,
            quantity: item.quantity,
        })),
        operatorId: values.operator.id,
        operatorName: values.operator.name,
        equipmentId: values.device.id,
        equipmentName: values.device.deviceName,
    }

    await service.transferOrderItems(request);
}
export default TransferOrderItemsUseCase